import { Injectable } from '@angular/core';
import { SharedService } from '../services/shared.service';
import { API_STATEMANAGEMENT } from '../shared/stateapimanagement/api-statemanagement';
import { Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class HomeLandingService {

  constructor(
    private sharedService : SharedService,
    public http: HttpClient
  ) { }

  userName:string;
  componentdestroyed: Subject<number> = new Subject();
  customerChangeLogggedOff: Subject<boolean> = new Subject();
  headers = new HttpHeaders({ 'content-type': 'application/json','charset':'utf-8'});

  // logSearchMetaData = this.sharedService.metaData.logsearch;
  // addSearch=this.logSearchMetaData.log_search_defaults.search_notebook

 stats = []
  // stats=[
  //   {
  //     "disp":"DATA INGESTED",
  //     "value":"data_ingested",
  //     "stat":"1.24",
  //     "icon":"storage",
  //     "icon_type":"trending_up",
  //     "diff":"+12%",
  //     "desc":"Total TB/day",
  //     "color":"#0079b8",
  //     "bg_color":"#eef7fc",
  //     "icon_color":"#2f8400"
  //   },
  //   {
  //     "disp":"ACTIVE ALERTS",
  //     "value":"active_alerts",
  //     "stat":"42",
  //     "icon":"notifications_active",
  //     "icon_type":"trending_up",
  //     "diff":"+8",
  //     "desc":"Total Count",
  //     "color":"#2f8400",
  //     "bg_color":"#fff5f5",
  //     "icon_color":"#2f8400"
  //   },
  //   {
  //     "disp":"SILENCE SOURCES",
  //     "value":"silence_sources",
  //     "stat":"03",
  //     "icon":"sensors_off",
  //     "icon_type":"check_circle_outline",
  //     "diff":"0",
  //     "desc":"Requires Action",
  //     "color":"#eb8d00",
  //     "bg_color":"#fffcf0",
  //     "icon_color":"#6a7282"
  //   },
  //   {
  //     "disp":"AVG EPS",
  //     "value":"avg_eps",
  //     "stat":"128",
  //     "icon":"speed",
  //     "icon_type":"trending_down",
  //     "diff":"-2",
  //     "desc":"Event Ingestion",
  //     "color":"#0079b8",
  //     "bg_color":"#eef7fc",
  //     "icon_color":"#e02200"
  //   }
  // ]

  titles={
    "name":"RITREEV",
    "overview_title":"RITREEV / OVERVIEW",
    "overview":"Overview",
    "overview_desc":"Overview of system security posture, live events, threat distribution, and analyst metrics.",
    "key_indicators":"KEY INDICATORS: ",
    "shortcuts":"SHORTCUTS",
    "welcome" : "Welcome ",
    "last_refreshed" : "Last Refreshed: "
  }

  statTime="PAST 24 HOURS"

  todayDate

  tooltip={
    "expand_nav":"Expand Navigation",
    "collapse_nav":"Collapse Navigation",
    "refresh":"Refresh"
  }

  providedashboardlist = new API_STATEMANAGEMENT(
    this.provideDashboardList, 
    this.http, 
    this.componentdestroyed.asObservable(), 
    this.customerChangeLogggedOff.asObservable()
)
provideDashboardList(pagination: any) {
 // return this.dashboardList
    return this.http.post(environment.apiUrl + '/studio/dashboard/list/get', pagination, { headers: this.headers })
}

dashboardGet(dashboard_req: any) {
  return this.http.post(environment.apiUrl + '/studio/dashboard_builder/dashboard/get', JSON.stringify(dashboard_req), { headers: this.headers })
}


provideStats = new API_STATEMANAGEMENT(
  this.providestats, 
  this.http, 
  this.componentdestroyed.asObservable(), 
  this.customerChangeLogggedOff.asObservable()
)
providestats(request: any) {
  return this.http.post(environment.apiUrl + '/app/homeStats/get', request, { headers: this.headers })
}

getSearchHistory = new API_STATEMANAGEMENT(
  this.getHistory, 
  this.http, 
  this.componentdestroyed.asObservable(), 
  this.customerChangeLogggedOff.asObservable()
)

getHistory(request) {
  return this.http.post<any>(environment.apiUrl + '/logsearch/history/get', request, { headers: this.headers });
}

tabList=[
  {
    "disp":"Recent Dashboards",
    "value":"recent_dashboards",
    "enable":true
  },
  {
    "disp":"Recent Searches",
    "value":"recent_searches",
    "enable":true
  }
]
dashboardHeaders=['DASHBOARD NAME','STATUS']

searchHeaders=['SEARCH QUERY','SEARCH TIME']

selectedTab = {
  "disp":"Recent Dashboards",
  "value":"recent_dashboards",
  "enable":true
}


}
